import React, { useEffect, useState, useContext } from "react";
import styles from "./RegisterAdmin.module.css";
import MenuAdmin from "../navAdmin/Menu";
import PageHeader from "../../pageheader/PageHeader";
import Select from "../../material/select/Select";
import Input from "../../material/input/Input";
import PasswordInput from "../../material/passwordInput/PasswordInput";
import Button from "../../material/button/Button";
import Datepicker from "../../material/datepicker/Datepicker";
import moment from "moment";
import * as publicApi from "../../../service/publicApi";
import { useLocation, useNavigate } from "react-router-dom";

import * as regex from "../../../service/regex";
import AutoComplete from "../../material/autoComplete/AutoComplete";

import { CurrentUserContext } from "../../../App";

function RegisterAdmin() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const nav = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState("");
  const [pname, setPname] = useState("");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [pid, setPid] = useState("");
  const [laserId, setLaserId] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState(null);
  // const [dayOB, setDayOB] = useState('')
  // const [monthOB, setMonthOB] = useState('')
  // const [yearOB, setYearOB] = useState('')
  const [address, setAddress] = useState("");
  const [moo, setMoo] = useState("");
  const [soy, setSoy] = useState("");
  const [road, setRoad] = useState();
  const [postCode, setPostCode] = useState("");
  const [provinceId, setProvinceId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [subDistrictId, setSubDistrictId] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [dayList, setDayList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [subDistrictList, setSubDistrictList] = useState([]);

  const [disablePname, setDisablePname] = useState(false);
  const [disableFname, setDisableFname] = useState(false);
  const [disableLname, setDisableLname] = useState(false);
  const [disablePid, setDisablePid] = useState(false);
  const [disableYearOB, setDisableYearOB] = useState(false);
  const [disableMonthOB, setDisableMonthOB] = useState(false);
  const [disableDayOB, setDisableDayOB] = useState(false);

  const [hospitalList, setHospitalList] = useState("");
  const [hospitalId, setHospitalId] = useState("");

  let userTypeList = [
    {
      key: "admin",
      value: "แอดมิน",
    },
    {
      key: "executive",
      value: "ผู้บริหาร",
    },
    {
      key: "hospital",
      value: "โรงพยาบาล",
    },
  ];
  let genderList = [
    {
      key: "male",
      value: "ชาย",
    },
    {
      key: "female",
      value: "หญิง",
    },
  ];
  let pnameList = [
    {
      key: "นาย",
      value: "นาย",
    },
    {
      key: "นาง",
      value: "นาง",
    },
    {
      key: "นางสาว",
      value: "นางสาว",
    },
  ];

  useEffect(() => {
    let dList = [];
    dList.push({ key: "", value: "ไม่ทราบวันเกิด" });
    for (let i = 0; i < 31; i += 1) {
      dList.push({
        key: String(i + 1).padStart(2, "0"),
        value: i + 1 + "",
      });
    }
    setDayList(dList);

    let mList = [
      {
        key: "",
        value: "ไม่ทราบเดือนเกิด",
      },
      {
        key: "01",
        value: "มกราคม",
      },
      {
        key: "02",
        value: "กุมภาพันธ์",
      },
      {
        key: "03",
        value: "มีนาคม",
      },
      {
        key: "04",
        value: "เมษายน",
      },
      {
        key: "05",
        value: "พฤษภาคม",
      },
      {
        key: "06",
        value: "มิถุนายน",
      },
      {
        key: "07",
        value: "กรกฎาคม",
      },
      {
        key: "08",
        value: "สิงหาคม",
      },
      {
        key: "09",
        value: "กันยายน",
      },
      {
        key: "10",
        value: "ตุลาคม",
      },
      {
        key: "11",
        value: "พฤศจิกายน",
      },
      {
        key: "12",
        value: "ธันวาคม",
      },
    ];
    setMonthList(mList);

    let yList = [];
    yList.push({ key: "", value: "ไม่ทราบปีเกิด" });
    let currentYear = moment().format("YYYY");
    for (let i = 0; i < 100; i += 1) {
      yList.push({
        key: currentYear - i + "",
        value: currentYear - i + 543 + "",
      });
    }
    setYearList(yList);
    const fetchData = async () => {
      await getProvinceList();
      await getHospitalList();
    };
    fetchData().then(() => {
      if (location.state) {
        filterData();
      }
    });
  }, []);

  const filterData = () => {
    let data = location.state;
    if (data.userType === "hospital") {
      setUserType(data.userType);
      setPname(data.pname);
      setFname(data.fname);
      setLname(data.lname);
      setPid(data.pid);
      setLaserId(data.laserId);
      setGender(data.gender);
      // setDayOB(data.dayOB)
      // setMonthOB(data.monthOB)
      // setYearOB(data.yearOB)
      if (data.dayOB && data.monthOB && data.yearOB) {
        setBirthday(new Date(`${data.yearOB}-${data.monthOB}-${data.dayOB}`));
      } else if (data.birthday) {
        setBirthday(data.birthday);
      }

      setAddress(data.address);
      setMoo(data.moo);
      setSoy(data.soy);
      setRoad(data.road);
      setProvinceId(data.provinceId);
      setProvinceList(data.provinceList);
      setDistrictId(data.districtId);
      setDistrictList(data.districtList);
      setSubDistrictId(data.subDistrictId);
      setSubDistrictList(data.subDistrictList);
      setPostCode(data.postCode);
      setPhoneNumber(data.phoneNumber);
      setEmail(data.email);
      setUserName(data.userName);
      setPassword(data.password);
      setConfirmPassword(data.confirmPassword);
      setHospitalId(data.hospitalId);
    } else {
      setUserType(data.userType);
      setPname(data.pname);
      setFname(data.fname);
      setLname(data.lname);
      setPid(data.pid);
      setLaserId(data.laserId);
      setGender(data.gender);
      // setDayOB(data.dayOB)
      // setMonthOB(data.monthOB)
      // setYearOB(data.yearOB)
      if (data.dayOB && data.monthOB && data.yearOB) {
        setBirthday(new Date(`${data.yearOB}-${data.monthOB}-${data.dayOB}`));
      } else if (data.birthday) {
        setBirthday(data.birthday);
      }
      setAddress(data.address);
      setMoo(data.moo);
      setSoy(data.soy);
      setRoad(data.road);
      setProvinceId(data.provinceId);
      setProvinceList(data.provinceList);
      setDistrictId(data.districtId);
      setDistrictList(data.districtList);
      setSubDistrictId(data.subDistrictId);
      setSubDistrictList(data.subDistrictList);
      setPostCode(data.postCode);
      setPhoneNumber(data.phoneNumber);
      setEmail(data.email);
      setUserName(data.userName);
      setPassword(data.password);
      setConfirmPassword(data.confirmPassword);
    }
  };

  const getProvinceList = async () => {
    setLoading(true);
    let res = await publicApi.getProvinceList();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setProvinceList(
          res["data"]["province_list"].map((item) => {
            return {
              key: item["province_id"],
              value: item["province_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setDistrictList(
          res["data"]["district_list"].map((item) => {
            return {
              key: item["district_id"],
              value: item["district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getSubDistrictList = async (id) => {
    setLoading(true);
    let res = await publicApi.getSubDistrictList(id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setSubDistrictList(
          res["data"]["sub_district_list"].map((item) => {
            return {
              key: item["sub_district_id"],
              value: item["sub_district_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getHospitalList = async () => {
    setLoading(true);
    let res = await publicApi.getHospitalList();
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setHospitalList(
          res["data"]["hospital_list"].map((item) => {
            return {
              id: item["hospital_id"],
              name: item["hospital_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const submitButtonClick = () => {
    if (userType === "hospital") {
      if (!pname) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
        return;
      }
      if (!fname) {
        setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ" });
        return;
      }
      if (!lname) {
        setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล" });
        return;
      }
      if (!pid) {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอกเลขบัตรประจำตัวประชาชน",
        });
        return;
      }
      if (!laserId) {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอกเลขหลังบัตรประจำตัวประชาชน",
        });
        return;
      }
      if (!gender) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกเพศ" });
        return;
      }
      if (!birthday) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกวันเกิด" });
        return;
      }
      // if (!dayOB) {
      //     setIsMessage('กรุณาเลือกวันเกิด')
      //     return
      // }
      // if (!monthOB) {
      //     setIsMessage('กรุณาเลือกเดือนเกิด')
      //     return
      // }
      // if (!yearOB) {
      //     setIsMessage('กรุณาเลือกปีเกิด')
      //     return
      // }
      if (!hospitalId) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกโรงพยาบาลที่สังกัด" });
        return;
      }
      // if (!address) {
      //     setIsMessage('กรุณากรอกที่อยู่')
      //     return
      // }
      // if (!moo) {
      //     setIsMessage('กรุณากรอกหมู่')
      //     return
      // }
      // if (!soy) {
      //     setIsMessage('กรุณากรอกซอย')
      //     return
      // }
      // if (!road) {
      //     setIsMessage('กรุณากรอกถนน')
      //     return
      // }
      if (!postCode) {
        setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
        return;
      }
      // if (!provinceId) {
      //     setIsMessage('กรุณาเลือกจังหวัด')
      //     return
      // }
      // if (!districtId) {
      //     setIsMessage('กรุณาเลือกอำเภอ')
      //     return
      // }
      // if (!subDistrictId) {
      //     setIsMessage('กรุณาเลือกตำบล')
      //     return
      // }
      if (!phoneNumber) {
        setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
        return;
      }
      // if (!userName) {
      //     setIsMessage('กรุณากรอกชื่อผู้ใช้งาน')
      //     return
      // }
      if (!password) {
        setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
        return;
      }
      if (!confirmPassword) {
        setIsMessage({ type: "warning", data: "กรุณากรอกยืนยันรหัสผ่าน" });
        return;
      }
      if (password !== confirmPassword) {
        setIsMessage({ type: "warning", data: "รหัสผ่านไม่ตรงกัน" });
        return;
      }

      nav("/permissionHospital", {
        state: {
          userType,
          pname,
          fname,
          lname,
          pid,
          laserId,
          gender,
          birthday,
          address,
          moo,
          soy,
          road,
          postCode,
          provinceId,
          districtId,
          subDistrictId,
          phoneNumber,
          email,
          userName,
          password,
          confirmPassword,
          provinceList,
          districtList,
          subDistrictList,
          hospitalId,
        },
      });
    } else {
      if (!userType) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกประเภทของผู้ใช้งาน" });
        return;
      }
      if (!pname) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกคำนำหน้า" });
        return;
      }
      if (!fname) {
        setIsMessage({ type: "warning", data: "กรุณากรอกชื่อ" });
        return;
      }
      if (!lname) {
        setIsMessage({ type: "warning", data: "กรุณากรอกนามสกุล" });
        return;
      }
      if (!pid) {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอกเลขบัตรประจำตัวประชาชน",
        });
        return;
      }
      if (!laserId) {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอกเลขหลังบัตรประจำตัวประชาชน",
        });
        return;
      }
      if (!gender) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกเพศ" });
        return;
      }
      if (!birthday) {
        setIsMessage({ type: "warning", data: "กรุณาเลือกวันเกิด" });
        return;
      }
      // if (!dayOB) {
      //     setIsMessage('กรุณาเลือกวันเกิด')
      //     return
      // }
      // if (!monthOB) {
      //     setIsMessage('กรุณาเลือกเดือนเกิด')
      //     return
      // }
      // if (!yearOB) {
      //     setIsMessage('กรุณาเลือกปีเกิด')
      //     return
      // }
      // if (!address) {
      //     setIsMessage('กรุณากรอกที่อยู่')
      //     return
      // }
      // if (!moo) {
      //     setIsMessage('กรุณากรอกหมู่')
      //     return
      // }
      // if (!soy) {
      //     setIsMessage('กรุณากรอกซอย')
      //     return
      // }
      // if (!road) {
      //     setIsMessage('กรุณากรอกถนน')
      //     return
      // }
      if (!postCode) {
        setIsMessage({ type: "warning", data: "กรุณากรอกรหัสไปรษณีย์" });
        return;
      }
      // if (!provinceId) {
      //     setIsMessage('กรุณาเลือกจังหวัด')
      //     return
      // }
      // if (!districtId) {
      //     setIsMessage('กรุณาเลือกอำเภอ')
      //     return
      // }
      // if (!subDistrictId) {
      //     setIsMessage('กรุณาเลือกตำบล')
      //     return
      // }
      if (!phoneNumber) {
        setIsMessage({ type: "warning", data: "กรุณากรอกเบอร์โทร" });
        return;
      }
      if (!email) {
        setIsMessage({ type: "warning", data: "กรุณากรอก Email" });
        return;
      }
      // if (!userName) {
      //     setIsMessage('กรุณากรอกชื่อผู้ใช้งาน')
      //     return
      // }
      if (!password) {
        setIsMessage({ type: "warning", data: "กรุณากรอกรหัสผ่าน" });
        return;
      }
      if (!confirmPassword) {
        setIsMessage({ type: "warning", data: "กรุณากรอกยืนยันรหัสผ่าน" });
        return;
      }
      if (password !== confirmPassword) {
        setIsMessage({ type: "warning", data: "รหัสผ่านไม่ตรงกัน" });
        return;
      }
      nav("/permissionAdmin", {
        state: {
          userType,
          pname,
          fname,
          lname,
          pid,
          laserId,
          gender,
          birthday,
          address,
          moo,
          soy,
          road,
          subDistrictId,
          districtId,
          provinceId,
          postCode,
          subDistrictList,
          districtList,
          provinceList,
          email,
          phoneNumber,
          userName,
          password,
          confirmPassword,
        },
      });
    }
  };

  const backButtonClick = () => {
    nav("/usermanagement");
  };

  return (
    <div className="global-page" style={{ paddingBottom: 100 }}>
      <MenuAdmin menuActive="usermanagement" />
      <PageHeader
        titlename="กรุณากรอกข้อมูลให้ครบถ้วน"
        description="เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป"
        btnBackWard
        backpath="/usermanagement"
      />

      <div className={styles.formContainer}>
        <Select
          list={userTypeList}
          value={userType}
          setValue={setUserType}
          placeholder="เลือกประเภทของผู้เข้าใช้งาน"
        />
        <div></div>
      </div>
      {userType === "hospital" ? (
        <>
          <div className={styles.formContainer} style={{ marginTop: 20 }}>
            <div className={styles.subTitle}>ข้อมูลส่วนตัว</div>
            <div></div>
            <Select
              label="เลือกคำนำหน้า"
              disabled={disablePname}
              value={pname}
              setValue={setPname}
              list={pnameList}
              placeholder="เลือกคำนำหน้า"
            ></Select>
            <div></div>
            <Input
              disabled={disableFname}
              placeholder="ชื่อ"
              value={fname}
              setValue={setFname}
            ></Input>
            <Input
              disabled={disableLname}
              placeholder="นามสกุล"
              value={lname}
              setValue={setLname}
            ></Input>
            <Input
              regex={regex.pid()}
              disabled={disablePid}
              placeholder="เลขบัตรประจำตัวประชาชน"
              value={pid}
              setValue={setPid}
            ></Input>
            <Input
              regex={regex.laserId()}
              placeholder="เลขหลังบัตรประจำตัวประชาชน"
              value={laserId}
              setValue={setLaserId}
            ></Input>
            <Select
              label="เพศ"
              placeholder="เพศ"
              value={gender}
              setValue={setGender}
              list={genderList}
            ></Select>
            <Datepicker
              label="วันเกิด"
              value={birthday}
              setValue={setBirthday}
            ></Datepicker>
            {/* <Select disabled={disableDayOB} placeholder="วันเกิด" value={dayOB} setValue={setDayOB} list={dayList}></Select>
                        <Select disabled={disableMonthOB} placeholder="เดือนเกิด" value={monthOB} setValue={setMonthOB} list={monthList}></Select>
                        <Select disabled={disableYearOB} placeholder="ปีเกิด" value={yearOB} setValue={setYearOB} list={yearList}></Select> */}
          </div>
          <div
            className={styles.formContainer}
            style={{ gridTemplateColumns: "1fr", marginTop: 20 }}
          >
            <AutoComplete
              id={hospitalId}
              placeholder="โรงพยาบาลต้นสังกัด"
              list={hospitalList}
              callBack={(res) => {
                setHospitalId(res["id"]);
              }}
            ></AutoComplete>
          </div>
          <div className={styles.formContainer} style={{ marginTop: 20 }}>
            <div className={styles.subTitle}>ที่อยู่ปัจจุบัน</div>
            <div></div>
            {/* <Input placeholder="ที่อยู่ (ชื่ออาคาร ตึก หรือบ้านเลขที่)" value={address} setValue={setAddress}></Input>
                        <Input placeholder="หมู่" value={moo} setValue={setMoo}></Input>
                        <Input placeholder="ซอย" value={soy} setValue={setSoy}></Input>
                        <Input placeholder="ถนน" value={road} setValue={setRoad}></Input>
                        <Select placeholder="จังหวัด" value={provinceId} setValue={(e) => {
                            setProvinceId(e)
                            setDistrictId('')
                            setDistrictList([])
                            setSubDistrictId('')
                            setSubDistrictList([])
                            getDistrictList(e)
                        }} list={provinceList}></Select>
                        <Select placeholder="อำเภอ" value={districtId} setValue={(e) => {
                            setDistrictId(e)
                            setSubDistrictId('')
                            setSubDistrictList([])
                            getSubDistrictList(e)
                        }} list={districtList}></Select>
                        <Select placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select> */}
            <Input
              regex={regex.postCode()}
              placeholder="รหัสไปรษณีย์"
              value={postCode}
              setValue={setPostCode}
            ></Input>
            <div></div>
            <Input
              placeholder="เบอร์โทร"
              value={phoneNumber}
              setValue={setPhoneNumber}
            ></Input>
            <Input
              label="Email (ถ้ามี)"
              placeholder="Email"
              value={email}
              setValue={setEmail}
            ></Input>
            <div className={styles.subTitle}>ตั้งค่าบัญชีผู้ใช้</div>
            <div></div>
          </div>
          {/* <div className={styles.formContainer} style={{ gridTemplateColumns: '1fr', marginTop: 20 }}>
                        <Input placeholder="ชื่อผู้ใช้งาน" value={userName} setValue={setUserName}></Input>
                    </div> */}
          <div className={styles.formContainer} style={{ marginTop: 20 }}>
            <div>
              <PasswordInput
                regex={regex.password()}
                placeholder="รหัสผ่าน"
                label="รหัสผ่าน"
                value={password}
                setValue={setPassword}
              ></PasswordInput>
              <div className={styles.formDetail}>
                รหัสควรประกอบด้วย ตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว และตัวเลข
              </div>
            </div>
            <PasswordInput
              regex={regex.password()}
              placeholder="ยืนยันรหัสผ่าน"
              value={confirmPassword}
              setValue={setConfirmPassword}
            ></PasswordInput>
          </div>
        </>
      ) : (
        <>
          <div className={styles.formContainer}>
            <div className={styles.subTitle}>ข้อมูลส่วนตัว</div>
            <div></div>
            <Select
              label="เลือกคำนำหน้า"
              value={pname}
              setValue={setPname}
              list={pnameList}
              placeholder="เลือกคำนำหน้า"
            ></Select>
            <div></div>
            <Input placeholder="ชื่อ" value={fname} setValue={setFname}></Input>
            <Input
              placeholder="นามสกุล"
              value={lname}
              setValue={setLname}
            ></Input>
            <Input
              regex={regex.pid()}
              placeholder="เลขบัตรประจำตัวประชาชน"
              value={pid}
              setValue={setPid}
            ></Input>
            <Input
              regex={regex.laserId()}
              placeholder="เลขหลังบัตรประจำตัวประชาชน"
              value={laserId}
              setValue={setLaserId}
            ></Input>
            <Select
              label="เพศ"
              placeholder="เพศ"
              value={gender}
              setValue={setGender}
              list={genderList}
            ></Select>
            <Datepicker
              label="วันเกิด"
              value={birthday}
              setValue={setBirthday}
            ></Datepicker>
            {/* <Select placeholder="วันเกิด" value={dayOB} setValue={setDayOB} list={dayList}></Select>
                        <Select placeholder="เดือนเกิด" value={monthOB} setValue={setMonthOB} list={monthList}></Select>
                        <Select placeholder="ปีเกิด" value={yearOB} setValue={setYearOB} list={yearList}></Select> */}
            <div className={styles.subTitle}>ที่อยู่ปัจจุบัน</div>
            <div></div>
            {/* <Input placeholder="ที่อยู่ (ชื่ออาคาร ตึก หรือบ้านเลขที่)" value={address} setValue={setAddress}></Input>
                        <Input placeholder="หมู่" value={moo} setValue={setMoo}></Input>
                        <Input placeholder="ซอย" value={soy} setValue={setSoy}></Input>
                        <Input placeholder="ถนน" value={road} setValue={setRoad}></Input>
                        <Select placeholder="จังหวัด" value={provinceId} setValue={(e) => {
                            setProvinceId(e)
                            setDistrictId('')
                            setDistrictList([])
                            setSubDistrictId('')
                            setSubDistrictList([])
                            getDistrictList(e)
                        }} list={provinceList}></Select>
                        <Select placeholder="อำเภอ" value={districtId} setValue={(e) => {
                            setDistrictId(e)
                            setSubDistrictId('')
                            setSubDistrictList([])
                            getSubDistrictList(e)
                        }} list={districtList}></Select>
                        <Select placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select> */}
            <Input
              regex={regex.postCode()}
              placeholder="รหัสไปรษณีย์"
              value={postCode}
              setValue={setPostCode}
            ></Input>
            <div></div>
            <Input
              placeholder="เบอร์โทร"
              value={phoneNumber}
              setValue={setPhoneNumber}
            ></Input>
            <Input
              placeholder="Email"
              value={email}
              setValue={setEmail}
            ></Input>
            <div className={styles.subTitle}>ตั้งค่าบัญชีผู้ใช้</div>
            <div></div>
          </div>
          {/* <div className={styles.formContainer} style={{ gridTemplateColumns: '1fr' }}>
                        <Input placeholder="ชื่อผู้ใช้งาน" value={userName} setValue={setUserName}></Input>
                    </div> */}
          <div className={styles.formContainer}>
            <div>
              <PasswordInput
                regex={regex.password()}
                placeholder="รหัสผ่าน"
                label="รหัสผ่าน"
                value={password}
                setValue={setPassword}
              ></PasswordInput>
              <div className={styles.formDetail}>
                รหัสควรประกอบด้วย ตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว และตัวเลข
              </div>
            </div>
            <PasswordInput
              regex={regex.password()}
              placeholder="ยืนยันรหัสผ่าน"
              value={confirmPassword}
              setValue={setConfirmPassword}
            ></PasswordInput>
          </div>
        </>
      )}
      {userType !== "" ? (
        <div className={styles.buttonContainer}>
          <Button
            style={{ width: 140, background: "#FFFFFF" }}
            onClick={backButtonClick}
          >
            ย้อนกลับ
          </Button>
          <Button style={{ width: 140 }} onClick={submitButtonClick}>
            ยืนยัน
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default RegisterAdmin;
